
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    export class SessionGrid extends SiteEntityGrid<SessionRow, any> {
        protected getColumnsKey() { return 'Rebalancer.Session'; }
        protected getDialogType() { return SessionDialog; }
        protected getIdProperty() { return SessionRow.idProperty; }
        protected getLocalTextPrefix() { return SessionRow.localTextPrefix; }
        protected getService() { return SessionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}